export const PROVIDER_NUMBERPLATE_SIV = 'siv'
export const PROVIDER_NUMBERPLATE_XASIS = 'Xasis'
export const PROVIDER_NUMBERPLATE_SANGUINETTI_IT = 'sanguinetti_italy'
export const PROVIDER_NUMBERPLATE_AUTOBIZ = 'autobiz'
